//TODO: Restructure hooks files to be more organized
import { queryCommonFlags } from "@/api/constants";
import { useCallback } from "react";
import { getRanks } from "@/modules/lead-page/api/lead-page.v2.api";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

const useFetchRanks = ({
  organizationUId,
  subDepartmentUId,
}: {
  organizationUId: string | undefined;
  subDepartmentUId?: string;
}) => {
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 50,
  });

  const [searchTerm, setSearchTerm] = useState("");

  const handlePageChange = useCallback((page: number) => {
    setPagination((prev: { page: number; pageSize: number }) => ({
      ...prev,
      page: page,
    }));
  }, []);

  const { data: ranks, isLoading } = useQuery(
    ["ranks", pagination, searchTerm, organizationUId, subDepartmentUId],
    () =>
      getRanks({
        page: pagination.page,
        pageSize: pagination.pageSize,
        ...(searchTerm && { title: searchTerm }),
        ...(organizationUId && { organizationUId }),
        ...(subDepartmentUId && { subDepartmentUId }),
      }),
    {
      ...queryCommonFlags,
      enabled: !!organizationUId,
    }
  );

  return {
    ranks: ranks?.data?.results || [],
    total: ranks?.data?.total,
    ranksLoading: isLoading,
    handlePageChange,
    pagination,
    searchTerm,
    setSearchTerm,
  };
};
export default useFetchRanks;
